export const EMOTIONS = ['enjoyment', 'fear', 'sadness', 'disgust', 'anger'] as const;
export type TopEmotion = (typeof EMOTIONS)[number];

export const EMOJI: Record<TopEmotion, string> = {
	enjoyment: '😊',
	fear: '😱',
	sadness: '😢',
	disgust: '🤢',
	anger: '😡',
};

export const EMOTION_SEARCH_QUERIES: Record<TopEmotion, string> = {
	enjoyment: 'happy',
	fear: 'fear',
	sadness: 'sad',
	disgust: 'daily',
	anger: 'anger',
};

export class EmotionUtils {
	static normalizeEmotion(raw?: string): TopEmotion {
		const emotion = String(raw ?? '')
			.toLowerCase()
			.trim();
		// Only accept exact emotion words
		if (EMOTIONS.includes(emotion as TopEmotion)) {
			return emotion as TopEmotion;
		}
		// Default fallback
		return 'enjoyment';
	}

	static getEmotionEmoji(emotion: TopEmotion): string {
		return EMOJI[emotion];
	}

	static getSearchQuery(emotion: TopEmotion): string {
		return EMOTION_SEARCH_QUERIES[emotion];
	}

	static getAllEmotions(): readonly TopEmotion[] {
		return EMOTIONS;
	}
}
